// Per-page product-class signal for popup page-type targeting. Pages that show
// hearing aids mount <RegisterProductClasses> — ProductContainer registers the
// one release's product_class, a compare page registers both sides — and
// SitePopups subscribes via useSyncExternalStore, mapping the classes to
// product-otc / product-prescription / product-hearable and, on compare pages,
// compare-otc / compare-prescription (match-path.ts resolvePopupPageTypes).
// A module-level store rather than React context because the writer (page
// body) and the reader (the layout-level popup controller) sit in unrelated
// trees.

const EMPTY: readonly string[] = []

let productClasses: readonly string[] = EMPTY
const listeners = new Set<() => void>()

// useSyncExternalStore compares snapshots by identity, so only swap the array
// when the contents actually change — a re-render with an equal list must
// return the same reference or it loops.
export const setProductClasses = (value: readonly string[]): void => {
  const next = value.length === 0 ? EMPTY : value
  if (next.length === productClasses.length && next.every((c, i) => c === productClasses[i])) {
    return
  }
  productClasses = next
  listeners.forEach((l) => l())
}

export const getProductClasses = (): readonly string[] => productClasses

// SSR snapshot for useSyncExternalStore — the server never knows a class.
export const getServerProductClasses = (): readonly string[] => EMPTY

export const subscribeProductClasses = (listener: () => void): (() => void) => {
  listeners.add(listener)
  return () => listeners.delete(listener)
}
